import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export const testimonialValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const reviewerName = control.get('reviewerName');
  const quote = control.get('quote');

  const isValid = reviewerName != null && reviewerName.value !== '' && quote != null && quote.value !== '';

  return isValid ? null : { valid: true };
};
